import React from 'react';
import { Link } from 'react-router-dom';
import './KosherCertificate.css';

const KosherCertificate = () => {
  return (
    <div className="page-container">
      <div className="page-content">
        <div className="page-main">
          <section className="page-section">
            <div className="page-breadcrumb">Product Certification</div>
            <h1 className="page-title">Kosher Certificate</h1>
            <div className="page-text-content">
              <p>
                Dear Visitors,
              </p>
              <p>
                We would like to share the details of the Kosher Certification, one of the 
                comprehensive certification services we offer at NQC (Nova Quality Certification Agency).
              </p>
            </div>
          </section>

          <section className="page-section">
            <h2 className="page-section-title">What is the Kosher Certification?</h2>
            <div className="page-text-content">
              <p>
                Kosher, a term of Hebrew origin, means "fit" or "clean." The Kosher Certification is 
                a certificate that verifies a product is produced in accordance with Jewish religious 
                laws and traditions. This certificate indicates that the product complies with specific 
                rules throughout all stages of production and can appeal to Jewish consumers.
              </p>
            </div>
          </section>

          <section className="page-section">
            <h2 className="page-section-title">Why Should I Get the Kosher Certification?</h2>
            <div className="reasons-list">
              <div className="reason-item">
                <h3 className="reason-title">1. Religious Compliance</h3>
                <p className="reason-description">
                  The Kosher Certification demonstrates that your products comply with Jewish religious 
                  laws, ensuring they are safe and suitable for Jewish consumers.
                </p>
              </div>
              <div className="reason-item">
                <h3 className="reason-title">2. Market Expansion</h3>
                <p className="reason-description">
                  Having a Kosher Certification allows your products to appeal to the Jewish community, 
                  potentially expanding your market reach.
                </p>
              </div>
              <div className="reason-item">
                <h3 className="reason-title">3. Consumer Confidence</h3>
                <p className="reason-description">
                  The Kosher Certification assures consumers that your products are carefully monitored 
                  during production and comply with specific standards.
                </p>
              </div>
              <div className="reason-item">
                <h3 className="reason-title">4. Global Market Access</h3>
                <p className="reason-description">
                  The Kosher Certification provides an opportunity to appeal not only to the Jewish 
                  community but also to consumers worldwide, allowing you to access global markets.
                </p>
              </div>
            </div>
          </section>

          <section className="page-section">
            <h2 className="page-section-title">How Does the Process Work to Obtain the Kosher Certification?</h2>
            <div className="page-text-content">
              <p>
                To obtain the Kosher Certification, you need to adjust your product's production 
                processes and ingredients to comply with specific Kosher standards. NQC (Nova Quality 
                Certification Agency) can guide you through this process and help you successfully 
                complete it.
              </p>
            </div>
          </section>

          <section className="page-section">
            <h2 className="page-section-title">Why Choose NQC (Nova Quality Certification Agency)?</h2>
            <div className="page-text-content">
              <p>
                NQC (Nova Quality Certification Agency) has extensive experience in religious compliance 
                certifications like the Kosher Certification. Our expert team provides tailored solutions 
                to meet your business needs and ensures you complete the certification process to the 
                highest standards.
              </p>
            </div>
          </section>

          <section className="page-section">
            <h2 className="page-section-title">Final Words</h2>
            <div className="page-text-content">
              <p>
                The Kosher Certification symbolizes the religious compliance and quality standards of 
                your products. At NQC (Nova Quality Certification Agency), we are pleased to assist 
                your business in obtaining this important certification. Feel free to contact us for 
                more information or to ask any questions.
              </p>
              <p>
                Best regards,
              </p>
            </div>
          </section>
        </div>

        <aside className="page-sidebar">
          <div className="sidebar-section">
            <h2 className="sidebar-title">Our Services</h2>
            <ul className="sidebar-links">
              <li><Link to="/system-certification">System Certification</Link></li>
              <li><Link to="/product-certification">Product Certification</Link></li>
              <li><Link to="/quality-certification">Quality Certification</Link></li>
            </ul>
          </div>
        </aside>
      </div>
    </div>
  );
};

export default KosherCertificate;

